import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {useSearchParams} from "react-router-dom";
import IconPdf from "../img/icons/icon-pdf.svg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";
import Pagination from "react-js-pagination";

export default function MemberResults(prop) {
    let [searchParams] = useSearchParams();

    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [yearListing, setYearListing] = React.useState(null);
    let [currentYear, setCurentYear] = React.useState(null);

    let refKeyword = React.useRef();

    React.useEffect(() => {
        if(searchParams.get('keyword')) {
            refKeyword.current.value = searchParams.get('keyword');
        }
        else {
            refKeyword.current.value = '';
        }

        if(searchParams.get('year')) {
            setCurentYear(searchParams.get('year'));
        }

        (async function() {
            try {
                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);

                    let yearArr = [];
                    for(let rs of resListing.rows) {
                        yearArr.push(prop.lang === 'en' ? new Date(rs.postDate).getFullYear() : new Date(rs.postDate).getFullYear()+543);
                    }
                    if(yearArr) {
                        yearArr = [...new Set(yearArr)];
                    }
                    setYearListing(yearArr);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let selectYear = null;
        if(searchParams.get('year')) {
            selectYear = searchParams.get('year');
        }

        const response = await fetch(Config.apiUrl +'memberResults/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                keyword: refKeyword.current.value,
                selectYear: selectYear ? (prop.lang === 'en' ? selectYear : selectYear-543) : null,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onSearch = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }

        let selectYear = null;
        if(searchParams.get('year')) {
            selectYear = searchParams.get('year');
            param.push('year=' + selectYear);
        }

        window.location = (prop.lang === 'en' ? '/en': '/') + 'member_results' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && refKeyword.current.value) {
            onSearch()
        }
    };

    const onChangeYear = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }

        if(e.target.value) {
            param.push('year=' + e.target.value);
        }

        window.location = (prop.lang === 'en' ? '/en': '/') + 'member_results' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container">
                    <div className="hgroup hgroup-search" data-aos="fade-in">
                        <h2 className="text-center text-primary">{prop.lang === 'en' ? 'Member Results':'ผลการดำเนินงานของสมาชิก'}</h2>
                        <div className="d-flex flex-wrap pt-3">
                            <div className="show-list">
                                <p>แสดงรายการ</p>
                                <select className="form-select" onChange={onChangeYear} value={currentYear}>
                                    <option value="">{prop.lang === 'en' ? 'Select Year':'เลือกปี'}</option>
                                    {
                                        yearListing && yearListing.length > 0 ?
                                            yearListing.map(function(item, i) {
                                                return <option key={i} value={item}>{item}</option>;
                                            }) : ''
                                    }
                                </select>
                            </div>

                            <div className="form-group search">
                                <input type="text" className="form-control" placeholder="ค้นหา" maxLength={50} ref={refKeyword} onKeyDown={handleKeyDown} />
                                <button className="btn btn-secondary" type="button" onClick={onSearch}>ค้นหา</button>
                            </div>
                        </div>
                    </div>

                    <div className="card-infos">
                        {
                            listing !== null && listing.count > 0 ?
                                <ul className="document-list">
                                    {
                                        listing.rows.map((row, index) => {
                                            return (
                                                <li key={index}>
                                                    <img className="icons" src={IconPdf} alt="PDF" />
                                                    <div>
                                                        <h3><a href={(prop.lang === 'en' ? '/en':'') + '/member_results/detail/' + row.slug}>{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</a>
                                                        </h3>
                                                        <p>{Utils.dateDMY(row.postDate, prop.lang, false)}</p>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul> : <p className="text-center">{prop.lang === 'en' ? 'Data Not Found':'ไม่พบข้อมูล'}</p>
                        }
                    </div>
                </div>
            </div>
        </>
    );
} 